import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api, fmtDateTime } from "@/lib/api";
import { GLASS } from "./CommandHeader";

const AGENTS = [["", "Tutti gli agenti"], ["booking", "Prenotazioni"], ["registration", "Iscrizioni"], ["clinic", "Economica"], ["cafe", "Café"], ["email", "Email"], ["director", "Director"]];

export function ActivityTimeline() {
  const [f, setF] = useState({ q: "", agent: "", only_admin: false });
  const [items, setItems] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => api.get("/superadmin/cc/activity", { params: f }).then(({ data }) => setItems(data)).catch(() => setItems([])), 300);
    return () => clearTimeout(t);
  }, [f]);
  return (
    <section className={`${GLASS} p-5`} data-testid="sa-activity-section">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <p className="font-display text-lg font-bold text-white">Centro attività AI</p>
        <div className="flex flex-wrap gap-2">
          <div className="relative"><Search className="absolute left-2.5 top-2.5 h-4 w-4 text-slate-500" /><input data-testid="sa-activity-search" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} placeholder="Cerca operazione o ID esecuzione" className="h-9 w-60 rounded-lg border border-slate-700 bg-slate-950 pl-8 pr-2 text-xs text-white placeholder:text-slate-500" /></div>
          <select data-testid="sa-activity-agent" value={f.agent} onChange={(e) => setF({ ...f, agent: e.target.value })} className="h-9 rounded-lg border border-slate-700 bg-slate-950 px-2 text-xs text-slate-200">{AGENTS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
          <label className="flex items-center gap-1.5 text-xs text-slate-300"><input data-testid="sa-activity-only-admin" type="checkbox" checked={f.only_admin} onChange={(e) => setF({ ...f, only_admin: e.target.checked })} className="accent-cyan-400" />Richiede intervento</label>
        </div>
      </div>
      <div className="max-h-[28rem] overflow-y-auto pr-1" data-testid="sa-activity-timeline">
        {!items && <div className="h-40 animate-pulse rounded-xl bg-slate-800/50" />}
        {items && !items.length && <p className="text-sm text-slate-500" data-testid="sa-activity-empty">Nessuna attività trovata.</p>}
        {items?.map((x) => (
          <div key={x.id} className="relative border-l border-slate-800 pb-5 pl-6 last:pb-0" data-testid={`sa-activity-${x.id}`}>
            <span className={`absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full ${x.result === "errore" ? "bg-red-500 shadow-[0_0_10px_#ef4444]" : x.needs_admin ? "bg-amber-400" : "bg-[#00F0FF] shadow-[0_0_8px_#00F0FF]"}`} />
            <p className="font-mono text-[10px] text-slate-500">{fmtDateTime(x.at)}{x.run_id && <> · <span className="text-slate-400">{x.run_id}</span></>}</p>
            <p className="text-sm text-slate-200"><b className="text-white">{x.agent}</b> · {x.action}</p>
            {x.detail && <p className={`text-xs ${x.result === "errore" ? "text-red-300" : "text-slate-400"}`}>{x.detail}</p>}
            <div className="mt-1 flex gap-2 font-mono text-[10px]">
              <span className={x.result === "errore" ? "text-red-400" : "text-emerald-400"}>{x.result === "errore" ? "errore" : "ok"}</span>
              {x.needs_admin && <span className="text-amber-300">richiede intervento</span>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
